App.Views.NotificationSubscription = {
  validateInput: function () {
    let isValid = true;
    const fields = App.Forms.NotificationSubscription.form.fields;

    if (fields.value.getValue() !== '' && !fields.type.disabled) {
      if (fields.type.getValue() === 'SMS') {
        isValid = Monet.Validators.isPhone(fields.value.getValue());
      }
      if (fields.type.getValue() === 'Email') {
        isValid = Monet.Validators.isEmail(fields.value.getValue());
      }
    }

    fields.value.dataIsInvalid = () => !isValid;
    if (isValid) {
      fields.value.rootEl.classList.remove('error');
    } else {
      fields.value.rootEl.classList.add('error');
    }
  },

  changeInputType: function () {
    const fields = App.Forms.NotificationSubscription.form.fields;
    const prefix = 'NotificationSubscription.field.';
    const fieldName = fields.type.getValue() === 'Email' ? 'email' : 'phone';
    fields.value.label.innerText = Monet.I18n.getResourcesByKey(prefix + fieldName);
    this.validateInput();
  },

  showEulaModal: function (e) {
    if (e.target.checked) {
      e.target.checked = false;

      // Create modal components
      const headerContainer = document.createElement('div');
      const headerTitle = document.createElement('h3');
      headerTitle.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey('NotificationSubscription.eulaModal.title').toUpperCase()));
      const headerSubtitle = document.createElement('div');
      headerSubtitle.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey('NotificationSubscription.eulaModal.subtitle')));
      headerContainer.appendChild(headerTitle);
      headerContainer.appendChild(headerSubtitle);

      const eulaContainer = document.createElement('iframe');
      eulaContainer.src = `https://myorder.greenmile.com/eula/?language=${Monet.I18n.locale.language}`;

      eulaContainer.sandbox = "allow-forms allow-scripts allow-same-origin allow-downloads allow-modals allow-presentation";

      const buttonSave = new Monet.UI.Fields.Button();
      buttonSave.setValue(Monet.I18n.getResourcesByKey('NotificationSubscription.eulaModal.agree'));
      buttonSave.addEventClickListener(() => {
        e.target.checked = true;
        modal.closeModalWindow();
      });

      const buttonCancel = new Monet.UI.Fields.Button();
      buttonCancel.setValue(Monet.I18n.getResourcesByKey('NotificationSubscription.eulaModal.disagree'));
      buttonCancel.addEventClickListener(() => {
        modal.closeModalWindow();
      });

      const buttonsContainer = document.createElement('div');
      buttonsContainer.className = 'buttonsContainer standard-form-buttons';
      buttonsContainer.appendChild(buttonSave.render());
      buttonsContainer.appendChild(buttonCancel.render());


      // Initialize and add modal contents to view
      const popupContent = document.createElement('div');
      popupContent.className = 'popupContent';
      popupContent.appendChild(headerContainer);
      popupContent.appendChild(eulaContainer);
      popupContent.appendChild(buttonsContainer);

      const modal = new Monet.Form.Modal("#NotificationSubscription");
      modal.showModalForm();
      const popupContainer = document.querySelector(".popupFormContainer");
      popupContainer.appendChild(popupContent);
    }
  },

  addEventListeners: function () {
    const fields = App.Forms.NotificationSubscription.form.fields;

    this.changeInputType();

    if (!fields.type.disabled) {
      fields.type.rootEl.addEventListener('click', () => this.changeInputType());
    }

    fields.value.input.addEventListener('input', () => this.validateInput());
    fields.status.input.addEventListener('change', this.showEulaModal);
  },

  disableFields: function () {
    const fields = App.Forms.NotificationSubscription.form.fields;
    const fieldsToDisable = ['type', 'value'];
    fieldsToDisable.forEach((key) => {
      fields[key].field.readOnly = true;
    });
  }
}
